import closeButton from '@/assets/icon/close.svg';
import downloadAppScanner from '@/assets/icon/download-app-scanner.webp';
import Icon from "@/components/units/Icon";

const QRCodeContainer = ({onClosehandler}) => {
  return (
    <>
        <div id="QR-Code-Container" className="tw-fixed tw-top-20 tw-right-0 tw-z-50 tw-hidden md:tw-block">
          <div className="tw-relative tw-bg-customTealLight tw-rounded-[10px] tw-shadow-lg tw-max-w-[9.375rem]">
            <div>
              <div className='tw-absolute -tw-top-2 -tw-left-2'>
                <img
                  src={closeButton}
                  className="tw-bg-white tw-p-2 tw-rounded-full tw-cursor-pointer"
                  onClick={onClosehandler}
                />
              </div>
              <div className="tw-p-4 tw-flex tw-flex-col tw-gap-2">
                <div className="tw-text-center tw-block tw-text-sm">
                  <span className="tw-block">Download Torus</span>
                  <span className="tw-block">Mobile App</span>
                </div>
                <img src={downloadAppScanner} className="tw-w-full tw-rounded-sm" />
                <div className="tw-flex tw-justify-around tw-text-[#001316]">
                  <Icon iconName="app-store-icon"/>
                  <Icon iconName="apple-icon" />
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default QRCodeContainer